<template>
  <div id="index">
    <Header />
    <Carousel />
    <BestSeller v-if="!this.isSaleSolar" />
    <BannerOffer v-if="!this.isSaleSolar" />
    <Releases v-if="!this.isSaleSolar" />
    <ProductsSolar v-if="this.isSaleSolar" />
    <SearchBrand />
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/template/Header";
import Carousel from "@/components/template/Carousel";
import BestSeller from "@/components/template/BestSeller";
import BannerOffer from "@/components/template/BannerOffer";
import Releases from "@/components/template/Releases";
import SearchBrand from "@/components/template/SearchBrand";
import Footer from "@/components/template/Footer";
import ProductsSolar from "@/components/template/ProductsSolar";

export default {
  data() {
    return {
      linkDaPagina: null,
      canalVendas: null,
      isSaleSolar: null,
    };
  },
  components: {
    Header,
    Carousel,
    BestSeller,
    BannerOffer,
    Releases,
    SearchBrand,
    Footer,
    ProductsSolar,
  },
  async created() {
    this.linkDaPagina = window.location.href;
    let canal = JSON.parse(localStorage.getItem("saleChannel"));
    this.isSaleSolar = JSON.parse(localStorage.getItem("isSaleSolar"));

    if (!canal) {
      localStorage.removeItem("login")
      window.location.href = "/login";
    }

    this.canalVendas = canal;
  },
  metaInfo() {
    return {
      title: "Leveros Integra | Climatização, Energia Solar e Refrigeração",
      meta: [
        {
          name: "description",
          content:
            "Ar-Condicionado, Refrigeração e eficiência energética você encontra na Leveros. Temos Solução completa com desconto em compras à vista, Confira!",
        },
        { name: "robots", content: "index,follow" },
        { name: "country", content: "BRA" },
        { name: "currency", content: "R$" },
        { name: "author", content: "Leveros Integra" },
        { name: "copyright", content: "Leveros Integra" },
        {
          property: "og:title",
          content:
            "Leveros Integra | Climatização, Energia Solar e Refrigeração",
        },
        {
          property: "og:description",
          content:
            "Ar-Condicionado, Refrigeração e eficiência energética você encontra na Leveros. Temos Solução completa com desconto em compras à vista, Confira!",
        },
        { property: "og:site_name", content: "Leveros Integra" },
        { property: "og:author", content: "Leveros Integra" },
        { property: "og:url", content: `${this.linkDaPagina}` },
        { property: "og:type", content: "company" },
      ],
      link: [{ rel: "canonical", href: `${this.linkDaPagina}` }],
    };
  },
};
</script>